import { formatNumber } from '@ab-core/functions/formatting/formatNumber';
import type { CounterReducerState } from '.';
import { MAX_INPUT_LENGTH } from '..';
import { getNextPossibleNumber } from '../utils';

export const checkAndGetValue = (
    props: CounterReducerState
): Pick<CounterReducerState, 'quantity' | 'formattedValue'> => {
    const newQuantity = getNextPossibleNumber({ ...props });

    return { quantity: newQuantity, formattedValue: getFormattedCounterNumber({ ...props, quantity: newQuantity }) };
};

export const getFormattedCounterNumber = (props: Pick<CounterReducerState, 'quantity' | 'quantityUnit'>): string => {
    const { quantityUnit, quantity } = props;
    const subString = MAX_INPUT_LENGTH;
    const shortenedQuantity = quantity.toString().substring(0, subString);
    const formattedNumber = formatNumber(shortenedQuantity) !== 'NaN' ? formatNumber(shortenedQuantity) : '';

    if (quantityUnit && quantityUnit !== '') {
        return `${formattedNumber} ${quantityUnit}`;
    }

    return formattedNumber;
};
